import { useCallback, useEffect, useState } from 'react';
import { fetchInvoices } from './api';
import type { BillingInvoice } from './types';

export interface BillingDataState {
  invoices: BillingInvoice[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function useBillingData(filters: {
  status: string[];
  invoiceType: string[];
  clientId?: string;
}): BillingDataState {
  const [state, setState] = useState<BillingDataState>({
    invoices: [],
    loading: true,
    error: null,
    reload: async () => undefined,
  });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const invoices = await fetchInvoices(filters);
      setState((s) => ({ ...s, invoices, loading: false, error: null }));
    } catch (err) {
      setState((s) => ({
        ...s,
        invoices: [],
        loading: false,
        error: err instanceof Error ? err.message : 'Ukendt fejl',
      }));
    }
  }, [filters.status.join(','), filters.invoiceType.join(','), filters.clientId]);

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, reload: load };
}
